import { useEffect, useState } from 'react';
import { useReducedMotion } from './useReducedMotion';

const formatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Kathmandu',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

/**
 * Real wall-clock time in Kathmandu — UTC+05:45, one of the few timezone
 * offsets not on the hour or half-hour, which is exactly why it reads as a
 * real place rather than a placeholder widget. Ticks every second; under
 * `prefers-reduced-motion` it renders once at mount and never updates again,
 * rather than animating a readout someone asked not to see move.
 */
export function useKathmanduClock(): string {
  const reduced = useReducedMotion();
  const [time, setTime] = useState(() => formatter.format(new Date()));

  useEffect(() => {
    if (reduced) return;
    const id = window.setInterval(() => setTime(formatter.format(new Date())), 1000);
    return () => window.clearInterval(id);
  }, [reduced]);

  return time;
}
